<template>
  <div class="container">
    <contract-locale class="no-print" />
    <div id="contract">
      <Header />
      <PartiesOutput />
      <Background />
      <ProductAndArea />
      <SupplierRightsAndObligations />
      <DistributorRightsAndObligations />
      <prices />
      <stock />
      <service />
      <patent-and-trademark />
      <sale-and-delivery />
      <secrets />
      <duration-and-resignation />
      <agreement-violation />
      <goodwill />
      <material-return />
      <handover />
      <venue-governing-law />
      <other-regulations />
      <appendix />
      <signature />
    </div>
  </div>
</template>

<script>
import ContractLocale from "./ContractLocale";
import Header from "./Header";
import PartiesOutput from "./PartiesOutput";
import Background from "./Background";
import ProductAndArea from "./ProductAndAreaOutput";
import SupplierRightsAndObligations from "./SupplierRightsAndObligationsOutput.vue";
import DistributorRightsAndObligations from "./DistributorRightsAndObligationsOutput.vue";
import Prices from "./PricesOutput.vue";
import Stock from "./StockOutput.vue";
import Service from "./ServiceOutput.vue";
import PatentAndTrademark from "./PatentAndTrademarkOutput.vue";
import SaleAndDelivery from "./SaleAndDeliveryOutput.vue";
import Secrets from "./SecretsOutput.vue";
import DurationAndResignation from "./DurationAndResignationOutput.vue";
import AgreementViolation from "./AgreementViolationOutput.vue";
import Goodwill from "./GoodwillOutput.vue";
import MaterialReturn from "./MaterialReturn.vue";
import Handover from "./HandoverOutput.vue";
import VenueGoverningLaw from "./VenueGoverningLawOutput.vue";
import OtherRegulations from "./OtherRegulationsOutput.vue";
import Appendix from "./AppendixOutput.vue";
import Signature from "./SignatureOutput.vue";
export default {
  components: {
    ContractLocale,
    Header,
    PartiesOutput,
    Background,
    ProductAndArea,
    SupplierRightsAndObligations,
    DistributorRightsAndObligations,
    Prices,
    Stock,
    Service,
    PatentAndTrademark,
    SaleAndDelivery,
    Secrets,
    DurationAndResignation,
    AgreementViolation,
    Goodwill,
    MaterialReturn,
    Handover,
    VenueGoverningLaw,
    OtherRegulations,
    Appendix,
    Signature
  },
  data() {
    return {
      outputObserver: ""
    };
  },
  mounted: function() {
    this.createOutputObserver();
    this.observeOutputElements();
  },
  methods: {
    /**
     *  These methods highlights the output fields in the contract component, whenever the user is typing in the corresponding input field.
     *  We use a mutation observer to register all user-output elements in the contract component for observation with one piece of code, intead of having to write 100 watcher methods.
     *  Whenever a user types something, the change in data will trigger the observer's callback. In this callback a css styling is applied to the html element and removed again after a short timeout event.
     *  Because each keyup event will trigger the callback, many timeout events can potentially be active at once. To make sure that only the last timeout event will remove the highlighted styles, each element
     *  is mapped together with a counter, and only when the last timeout event is running, will the last highlighted styles be removed.
     */
    createOutputObserver() {
      const highlightClass = "highlight-text";
      const timeoutDuration = 500;
      let counterCollection = new Map();

      this.outputObserver = new MutationObserver(function(mutations) {
        for (let i = 0; i < mutations.length; i++) {
          mutationCallback(mutations[i].target.parentNode);
        }
      });

      let mutationCallback = function(element) {
        let counter = counterCollection.get(element);

        if (counter == undefined) {
          counter = 0;
        }

        counterCollection.set(element, ++counter);

        setTimeout(() => timeoutCallback(element), timeoutDuration);

        element.classList.add(highlightClass);
      };

      let timeoutCallback = function(element) {
        let counter = counterCollection.get(element);
        counterCollection.set(element, --counter);

        if (counter > 0) {
          return;
        }
        counterCollection.delete(element);
        element.classList.remove(highlightClass);
      };
    },

    /*
        Register all user-output elements for observation
      */
    observeOutputElements() {
      let observedElements = this.$el.querySelectorAll(".user-output");
      for (let i = 0; i < observedElements.length; i++) {
        this.outputObserver.observe(observedElements[i], {
          characterData: true,
          subtree: true
        });
      }
    }
  }
};
</script>

<style>
#contract {
  box-sizing: border-box;
  border: 1px solid black;
  padding: 1rem 1rem;
}

#contract h1 {
  text-align: center;
  font-size: 1.2rem;
}

.sub-title {
  text-transform: uppercase;
  font-size: 20px;
  margin-bottom: 20px;
  text-align: center;
}

.margin-right-number {
  margin-right: 0.6rem;
}

.margin-left {
  margin-left: 1.5rem;
}

.user-output {
  transition: background 0.2s ease-in-out;
}

.highlight-text,
.highlight-enter {
  background: #1cd6ac;
}

.highlight-enter-active {
  transition: background 1s ease-in-out;
}

.highlight-enter-to {
  background: white;
}

.square {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 1px solid #000;
  margin-right: 0.5rem;
  padding-top: 1px;
  padding-bottom: 1px;
}

.square .fa-check {
  position: relative;
  top: -3px;
  font-size: 18px;
}

.square .fa-times {
  position: relative;
  top: -4px;
  left: 2px;
  font-size: 17px;
}

hr {
  border-top: 1px solid #000 !important;
  margin-top: 0;
}

div.container.no-padding-margin {
  padding-left: 0px;
  padding-right: 0px;
  margin-left: 0px;
  margin-right: 0px;
}

.inline-wrap {
  display: flex;
  flex-wrap: wrap;
}

.bold {
  font-weight: bold;
}

ul,
ol {
  padding-left: 10px !important;
}

@media only screen and (min-width: 426px) {
  #contract h1 {
    font-size: 1.2rem;
  }
}

@media only screen and (min-width: 769px) {
  #contract {
    padding: 1rem 2rem;
  }

  #contract h1 {
    font-size: 1.5rem;
  }
}

@media only screen and (min-width: 1025px) {
  #contract {
    padding: 1rem 3rem;
  }

  #contract h1 {
    font-size: 2rem;
  }
}

@media print {
  #contract {
    border: 0;
    padding: 0;
    margin: 0;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 1.5rem;
  }

  #contract h1 {
    font-size: 3rem;
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  #contract .headline {
    font-size: 2rem;
  }
}

@page {
  margin: 3.5cm;
}
</style>



// WEBPACK FOOTER //
// src/apps/eneforhandler/components/contract/Contract.vue